import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

export default function RouteIcon(props) {
    return (
        <SvgIcon style={{"fontSize": props.fontSize}}>
            <svg version="1.0" viewBox="0 0 180.000000 180.000000"
                 preserveAspectRatio="xMidYMid meet">

                <g transform="translate(0.000000,180.000000) scale(0.100000,-0.100000)"
                   fill={props.color} stroke="none">
                    <path d="M501 1438 c-29 -14 -53 -37 -72 -67 -59 -92 -32 -183 93 -316 l61
-66 44 43 c24 24 65 73 90 110 37 55 47 78 50 120 6 77 -26 134 -96 170 -64
33 -110 35 -170 6z m159 -30 c53 -27 83 -75 83 -132 0 -52 -17 -85 -95 -182
l-62 -77 -39 44 c-58 66 -116 157 -123 195 -9 50 30 123 81 151 51 29 99 29
155 1z"/>
                    <path d="M525 1339 c-28 -25 -35 -38 -35 -68 1 -39 12 -58 50 -84 37 -26 77
-21 111 12 48 49 38 125 -21 156 -43 22 -65 19 -105 -16z m114 -25 c12 -15 21
-34 21 -44 0 -30 -39 -70 -69 -70 -45 0 -71 26 -71 70 0 29 6 43 22 54 34 24
73 20 97 -10z"/>
                    <path d="M597 963 c-4 -3 -2 -12 4 -19 13 -16 54 0 44 17 -7 10 -38 12 -48 2z"/>
                    <path d="M735 949 c-8 -12 14 -31 30 -26 6 2 10 10 10 18 0 17 -31 24 -40 8z"/>
                    <path d="M820 916 c0 -17 27 -29 35 -16 4 6 3 15 0 20 -9 15 -35 12 -35 -4z"/>
                    <path d="M1091 878 c-29 -14 -53 -37 -72 -67 -59 -92 -32 -183 93 -316 l61
-66 44 43 c24 24 65 73 90 110 37 55 47 78 50 120 6 77 -26 134 -96 170 -64
33 -110 35 -170 6z m159 -30 c53 -27 83 -75 83 -132 0 -52 -17 -85 -95 -182
l-62 -77 -39 44 c-58 66 -116 157 -123 195 -9 50 30 123 81 151 51 29 99 29
155 1z"/>
                    <path d="M1115 779 c-28 -25 -35 -38 -35 -68 1 -39 12 -58 50 -84 37 -26 77
-21 111 12 48 49 38 125 -21 156 -43 22 -65 19 -105 -16z m114 -25 c12 -15 21
-34 21 -44 0 -30 -39 -70 -69 -70 -45 0 -71 26 -71 70 0 29 6 43 22 54 34 24
73 20 97 -10z"/>
                    <path d="M895 881 c-8 -15 3 -31 21 -31 9 0 14 7 12 17 -4 20 -24 28 -33 14z"/>
                    <path d="M954 806 c-8 -21 3 -49 16 -41 5 3 10 15 10 25 0 25 -18 36 -26 16z"/>
                    <path d="M917 723 c-4 -3 -7 -12 -7 -20 0 -17 26 -17 33 1 8 21 -11 35 -26 19z"/>
                    <path d="M825 670 c-8 -12 20 -24 35 -15 5 3 10 10 10 16 0 12 -37 12 -45 -1z"/>
                    <path d="M744 649 c-3 -6 -1 -16 4 -21 13 -13 45 8 36 23 -7 12 -31 11 -40 -2z"/>
                    <path d="M686 583 c-10 -25 10 -39 23 -15 10 19 6 32 -10 32 -4 0 -10 -8 -13
-17z"/>
                    <path d="M654 495 c-7 -17 4 -37 17 -30 12 8 12 45 -1 45 -6 0 -13 -7 -16 -15z"/>
                    <path d="M700 421 c0 -21 26 -36 36 -20 6 11 -13 39 -27 39 -5 0 -9 -9 -9 -19z"/>
                    <path d="M1096 422 c-15 -14 -5 -33 17 -30 26 4 30 30 5 34 -9 1 -19 -1 -22
-4z"/>
                    <path d="M780 395 c0 -11 7 -15 23 -13 12 2 22 8 22 13 0 6 -10 11 -22 13 -16
2 -23 -2 -23 -13z"/>
                    <path d="M870 400 c-11 -7 -12 -12 -3 -21 14 -14 46 -4 41 13 -6 16 -20 19
-38 8z"/>
                    <path d="M957 404 c-14 -14 -6 -24 19 -24 16 0 24 5 22 13 -5 14 -31 21 -41
11z"/>
                </g>
            </svg>
        </SvgIcon>
    )
}